import React from "react";
import { Grid } from "@material-ui/core";
import { TextField } from "@ofqual/portal-components/components/TextField";

import { ApprovalDialogItemProps } from "./DialogProps";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import { cachedCountriesService } from "../../../services";
import { convertToHumanReadable } from "./DialogValueHelpers";

export const ApprovalDialogItemCountry: React.FC<ApprovalDialogItemProps> = ({
  change,
}) => {
  const [countriesLookup] = useLookup(cachedCountriesService);
  const oldValueLookup = convertToHumanReadable(
    countriesLookup.find((x) => x.id === +change.oldValue)?.label || "");

  const newValueLookup = convertToHumanReadable(
    countriesLookup.find((x) => x.id === +change.newValue)?.label || "");
  return (
    <>
      <Grid item md={12}>
        <TextField
          data-test="change-old-value"
          value={oldValueLookup}
          label="Old Value"
          fullWidth
          variant="outlined"
          disabled
        />
      </Grid>
      <Grid item md={12}>
        <TextField
          data-test="change-new-value"
          value={newValueLookup}
          label="New Value"
          fullWidth
          variant="outlined"
          disabled
        />
      </Grid>
    </>
  );
};
